import { render } from "./RegistroActividad.vue?vue&type=template&id=3d6195ea&scoped=true"
import script from "./RegistroActividad.vue?vue&type=script&lang=js"
export * from "./RegistroActividad.vue?vue&type=script&lang=js"

import "./RegistroActividad.vue?vue&type=style&index=0&id=3d6195ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6195ea"]])

export default __exports__